import * as yup from 'yup'

export class NeedsClusterReinstalledImporterDoorLabelPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    clusterReinstallImporterDoorLabelPhotoFile?: File = undefined
}

export const NeedsClusterReinstalledImporterDoorLabelPhotoDtoSchema = yup.object({
    clusterReinstallImporterDoorLabelPhotoFile: yup
    .mixed()
    // @ts-ignore
    .test('Importer Door Label Photo is Required..', 'File ', (value: File) => value)
    .required('Importer Door Label Photo is Required.')
})
